import { MotorcycleProductIntroFormValues } from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/Motorcycle/motorcycleInterface";
import { setField } from "Utils/formUtils";
import { FormikProps } from "formik";
import { CarProductIntroFormValues } from "../interfaces";
import { resetSelectedModel } from "./resetSelectedModel";

export const resetSelectedYear = (
  formProps: FormikProps<
    CarProductIntroFormValues | MotorcycleProductIntroFormValues
  >,
): void => {
  setField(formProps, "brand", "", false);
  resetSelectedModel(formProps);
};
